import "../WakeUpScreen.css";

export default function WakeUpScreen() {
  return (
    <div className="wakeup-container">
      <h1 className="wakeup-logo">Career Engine</h1>
      <p className="wakeup-status">Waking up server...</p>
      <div className="wakeup-bar-track">
        <div className="wakeup-bar-fill" />
      </div>
      <p className="wakeup-hint">This may take up to a minute on first load</p>
    </div>
  );
}
